<template lang="pug">
#modal-visualizar-informacao-territorio-monitoramento(
    v-if='show && situacao !== {}'
)
    el-dialog(
        :visible.sync='show',
        :before-close='closeModal',
        :close-on-click-modal='false',
        width='750px'
    )
        .template(slot='title')
            .box-header
                .box-header--icon
                    i.mdi.mdi-alert-outline
                .box-header--title
                    | {{ situacao.camadaCategoria.nome }}
        .conteudo
            .conteudo-esquerda
                .conteudo-esquerda-lista(
                    v-if='!situacao.camadaCategoria.codigo.includes("REPRESENTANTES")'
                )
                    h3 Situação do território
                    DiagnosticoSocioambiental(
                        :dadosConsulta='situacao',
                        :habilitar-sinal-aviso='true',
                        @index-aberto='atualizarRestricaoMapa'
                    )
                    .conteudo-cars-vinculados(
                        v-if='cars != null && cars.cars.length > 0'
                    )
                        h3 CARs vinculados
                        el-collapse.mx-2(v-model='carAtivo', :accordion='true')
                            el-collapse-item.conteudo-car-vinculado(
                                :name='index'
                            )(
                                v-for='(c, index) in cars.cars',
                                :key='index'
                            )
                                p(slot='title')
                                    span.codigo {{ c.codigo }}<br>
                                    b {{ $t('mensagens.diagnosticoSocioambiental.propriedadesCamada.situacao') }}:
                                    span "{{ c.condicao }}"

                                DiagnosticoSocioambiental(
                                    :dadosConsulta='c.situacao',
                                    :habilitar-sinal-aviso='true',
                                    :indexCollapse='index + 20',
                                    :fecharCollapses='true',
                                    @index-aberto='atualizarRestricaoMapa'
                                )

                .conteudo-esquerda-lista(v-else)
                    .representantes.mt-3(
                        v-for='(representante, index) in situacao.diagnosticoPorRepresentante'
                    )
                        .mb-3
                            .dados-label
                                h4
                                    i.flow.flow-user-second
                                    | Pessoa
                            span {{ representante.nomeRepresentante }}
                        DiagnosticoSocioambiental(
                            :dadosConsulta='representante',
                            :habilitar-sinal-aviso='true'
                        )

            .conteudo-direita
                mapa(
                    height='100%',
                    idMapa='MapaModalVisualizarInformacaoTerritorioMonitoramento',
                    :key='keyMapa',
                    :mapLayersConfigs='camadasMapa',
                    :mapConfig='configuracoesMapa',
                    ref='map'
                )
</template>

<script>
import Mapa from '@/components/MapaLeaflet.vue';
import DiagnosticoSocioambiental from '@/components/diagnosticoSocioambiental/index.vue';
import { getEstiloGeometria } from '@/utils/mapa/mapa.estilos';
import centroidFromGeoJSON from '@/utils/centroidFromGeoJSON';
import EventBus from '@/utils/eventBus';
// import EventBus from '@/utils/eventBus';

export default {
    name: 'ModalVisualizarInformacaoTerritorioMonitoramento',

    props: {
        situacao: {
            type: Object,
            required: true,
            default() {
                return {};
            }
        },
        territorio: {
            type: Object,
            required: true,
            default() {
                return {};
            }
        },
        show: {
            default: false,
            type: Boolean
        },
        cars: {
            type: Object,
            required: false,
            default() {
                return {};
            }
        }
    },
    emits: ['close', 'fecharCollapses'],
    components: {
        Mapa,
        DiagnosticoSocioambiental
    },

    data() {
        return {
            camadasMapa: [],
            configuracoesMapa: {
                controls: {
                    zoomControl: true,
                    camadasControl: true,
                    fullscreen: true
                },
                inspecionar: false,
                diagnostico: false
            },
            keyMapa: 1,
            camadaCentralizadaNome: null,
            tagUltimaRestricaoAberta: null,
            areasRestricao: [],
            carAtivo: null
        };
    },
    watch: {
        show(_new, _old) {
            if (_new) {
                this.configureLayersMapa();
            }
        },
        carAtivo() {
            this.mostrarCAR();
        }
    },
    methods: {
        mostrarCAR() {
            EventBus.$emit('fecharCollapses');

            this.camadasMapa = this.camadasMapa.filter(l => l.group !== 'car');

            this.fecharDiagnosticoCar = true;

            if (this.carAtivo || this.carAtivo === 0) {
                const c = this.cars.cars[this.carAtivo];

                this.camadasMapa.push({
                    style: getEstiloGeometria('car'),
                    name: c.codigo,
                    geoJson: c.geometria,
                    featureGroup: true,
                    group: 'car'
                });
            }
        },
        closeModal() {
            this.carAtivo = null;
            this.camadasMapa = [];
            this.$emit('close');
        },
        configureLayersMapa() {
            this.camadasMapa = [];

            let layerAreaMonitorada = {
                style: getEstiloGeometria('area'),
                name: 'Área Monitorada',
                geoJson: this.territorio.geometria
            };

            this.camadasMapa.push(layerAreaMonitorada);
        },

        mostrarAreasDiagnosticoNoMapa(tagRestricao, group, restricao) {
            const opacidade =
                this.areasRestricao.camada.opacidade >= 0.0
                    ? this.areasRestricao.camada.opacidade / 200
                    : 0.5;

            this.areasRestricao.areas.forEach((area, index) => {
                this.camadasMapa.push({
                    style: {
                        color: 'red',
                        weight: 1,
                        fill: true,
                        opacity: opacidade,
                        fillOpacity: opacidade
                    },
                    name: `AreaDiagnostico ${index}`,
                    tagRestricao,
                    group,
                    geoJson: area
                });

                const pin = L.icon({
                    iconUrl:
                        'https://lyra-v1.s3.amazonaws.com/Pin+da+restricao.png',
                    iconSize: [18, 18]
                });

                this.camadasMapa.push({
                    name: `CentroidDiagnostico ${index}`,
                    icon: pin,
                    tagRestricao,
                    group,
                    geoJson: centroidFromGeoJSON.get(area)
                });
            });
        },

        atualizarRestricaoMapa(restricao, indexCollapse, indexCollapseRow) {
            this.camadasMapa = this.camadasMapa.filter(
                l => l.tagRestricao !== this.tagUltimaRestricaoAberta
            );

            if (indexCollapseRow && indexCollapseRow !== '') {
                this.tagUltimaRestricaoAberta = `${indexCollapseRow}`;
                this.areasRestricao = [];
                let restricoes = [];
                let group = '';

                if (indexCollapse < 20) {
                    this.tagUltimaRestricaoAberta += '-area';
                    group += `grupo-restricoes-${indexCollapse}-${indexCollapseRow}`;

                    restricoes = this.situacao.diagnosticos;

                    this.areasRestricao = {
                        areas: restricoes[indexCollapseRow].resultados.map(
                            r => r.geometry
                        ),
                        camada: restricoes[indexCollapseRow].camada
                    };
                } else {
                    this.tagUltimaRestricaoAberta += '-car';
                    group += 'car';

                    restricoes =
                        this.cars.cars[indexCollapse - 20].situacao
                            .diagnosticos;

                    this.areasRestricao = {
                        areas: restricoes[indexCollapseRow].resultados.map(
                            r => r.geometria
                        ),
                        camada: restricoes[indexCollapseRow].camada
                    };
                }

                this.mostrarAreasDiagnosticoNoMapa(
                    this.tagUltimaRestricaoAberta,
                    group,
                    restricao
                );
            }
        }
    }
};
</script>

<style lang="scss">
#modal-visualizar-informacao-territorio-monitoramento {
    .el-dialog__wrapper {
        top: -15px !important;
    }

    .el-dialog {
        width: 69% !important;
    }

    .el-dialog__header {
        background: var(--operation-awaiting-approval);
    }

    .box-header {
        display: flex;
        align-items: center;
        justify-content: flex-start;

        .box-header--icon {
            margin-right: 10px;
        }

        .box-header--title {
            color: var(--warning);
            font-size: 20px;
        }

        .mdi:before,
        .mdi-set {
            font-size: 19px;
            color: var(--warning);
        }
    }

    .conteudo {
        display: flex;
        height: 500px;

        .conteudo-esquerda {
            width: 40%;

            h3 {
                margin-bottom: 10px;
                color: var(--black);
            }

            .conteudo-esquerda-lista {
                max-height: 475px;
                overflow-y: auto;
                display: flex;
                flex-direction: column;
                margin-right: 10px;

                #diagnostico-socioambiental {
                    display: block;
                }
            }

            .representantes {
                &:first-child {
                    margin-top: 0px !important;
                }

                .dados-label {
                    margin-bottom: 5px;

                    h4 {
                        margin-top: 10px;
                        color: var(--black);

                        i {
                            padding-right: 5px;
                        }
                    }
                }
            }
        }

        .conteudo-direita {
            width: 60%;
        }

        .conteudo-car-vinculado {
            color: black;
            margin-top: 20px;
        }

        .conteudo-car-vinculado span.codigo {
            font-size: 14px;
        }
    }
}
</style>
